import cn from 'classnames';
import React from 'react';

import Message from '@sats-group/ui-lib/react/message/message';
import Text from '@sats-group/ui-lib/react/text/text';

import CampaignBanner from 'shared/components/campaign-banner/campaign-banner';
import ContentContainer from 'shared/components/content-container/content-container';
import { useMessage } from 'shared/hooks/use-message';

import LayoutHeader from '../layout-header/layout-header';

import type { Layout as Props } from './layout.props';

const Layout: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  campaignBanner,
  campaignDisclaimer,
  contentWidth = ContentContainer.themes.wide,
  header,
  language,
  messages = [],
  title,
  alignTitleLeft,
}) => {
  const { messagesQueue, getAction } = useMessage(messages, language);

  return (
    <div className="layout">
      <LayoutHeader {...header} />
      <ContentContainer className="layout__main" theme={contentWidth}>
        {campaignBanner ? (
          <div className="layout__campaign-banner">
            <CampaignBanner {...campaignBanner} />
          </div>
        ) : null}
        <Text
          className={cn('layout__title', {
            'layout__title--left': alignTitleLeft,
          })}
          elementName="h1"
          size={'headline2'}
          theme={Text.themes.headline}
          italic
        >
          {title}
        </Text>
        {messagesQueue.length ? (
          <div className="layout__messages">
            {messagesQueue.map(message => (
              <Message
                key={message.text}
                inline
                {...message}
                action={getAction(message)}
              />
            ))}
          </div>
        ) : null}
        {children}
        {campaignDisclaimer ? (
          <div
            className={cn('layout__campaign-disclaimer', {
              'layout__campaign-disclaimer--left': alignTitleLeft,
            })}
          >
            <Text theme={Text.themes.emphasis} size={Text.sizes.interface}>
              {campaignDisclaimer.campaign}
            </Text>
            <Text size={Text.sizes.interface}>
              {campaignDisclaimer.disclaimer}
            </Text>
          </div>
        ) : null}
      </ContentContainer>
    </div>
  );
};

export default Layout;
